import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const classes = {
  root: css`
    display: flex;
    flex-direction: column;
    height: 100vh;
  `,
  backButtonContainer: css`
    padding: ${spacing(1)};
  `,
  backButton: css`
    width: fit-content;
  `,
  item: css`
    padding: ${spacing(2)};
  `,
  illustration: css`
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  `,
  illustrationImage: css`
    width: ${spacing(20)};
    height: ${spacing(20)};
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
  `,
  illustrationText: css`
    text-align: center;
    white-space: pre-line;
  `,
}
